import React from 'react';
import { Box } from '@mui/material';

// RacsLogo tries to load /racs-logo.png (the provided image). If not present,
// it falls back to the bundled /racs-logo.svg.
const RacsLogo: React.FC<{ size?: number }> = ({ size = 100 }) => {
  const s = size;
  const [src, setSrc] = React.useState<string>('/racs_logo.png');

  return (
    <Box sx={{ width: s, height: s, display: 'inline-block' }}>
      <img
        src={src}
        alt="RACS"
        onError={() => {
          const current = String(src);
          if (current === '/racs_logo.png') {
            setSrc('/racs-logo.png');
            return;
          }
          if (current === '/racs-logo.png') {
            setSrc('/racs-logo.svg');
            return;
          }
          if (current !== '/racs-logo.svg') {
            setSrc('/racs-logo.svg');
          }
        }}
        style={{ width: s, height: s, objectFit: 'contain' }}
      />
    </Box>
  );
};

export default RacsLogo;
